@if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<div>
  <h1>IT-Security Check</h1>
  <form [formGroup]="oderIDsForm">
    <div formArrayName="oderIDs">
      <div *ngFor="let orderControl of oderIDs.controls; let i = index">
        <mat-form-field appearance="fill">
          <mat-label>Order ID {{ i + 1 }}</mat-label>
          <!-- The input is bound to the current FormControl in the FormArray -->
          <input matInput [formControlName]="i" placeholder="Enter Order ID">
        </mat-form-field>
      </div>
    </div>

    <!-- Button to add a new order ID field -->
    <button mat-icon-button type="button" (click)="addOrderID()">
      <mat-icon>add</mat-icon>
    </button>
  </form>
</div>

<form [formGroup]="comments">
  <mat-form-field appearance="fill">
    <mat-label>Generic Comment</mat-label>
    <textarea matInput formControlName="genericComment" placeholder="Enter your comment"></textarea>
  </mat-form-field>
</form>

<button mat-raised-button color="primary" type="button" (click)="submitItSecurityCheck()">
  Absenden
</button>
